import request from '../utils/request'

export function getVerify(object) {
    return request.get('/captcha/captchaImage', object)
}

export function getIndexData(object) {
    return request.post('/index/getIndexData', object)
}
